import pokemon from "./pokemon";
import { combineReducers } from "redux";

export default combineReducers({
  pokemon,
});
